import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ContactUs from './pages/ContactUs';
import MockupPreview from './pages/MockupPreview';
import GuarantorReview from './pages/GuarantorReview';
import PayDeal from './pages/PayDeal';

// Account Pages
import { AccountAuthProvider } from './contexts/AccountAuthContext';
import AccountEntry from './pages/account/AccountEntry';
import AccountDashboard from './pages/account/AccountDashboard';
import AccountPlans from './pages/account/AccountPlans';
import AccountCheckout from './pages/account/AccountCheckout';
import AccountCheckoutSuccess from './pages/account/AccountCheckoutSuccess';
import AccountPayment from './pages/account/AccountPayment';
import AccountCancel from './pages/account/AccountCancel';
import AccountPaymentHistory from './pages/account/AccountPaymentHistory';
import AccountMySubscription from './pages/account/AccountMySubscription';
import AccountBusinessProfile from './pages/account/AccountBusinessProfile';

// Account Layout Wrapper - provides auth context for all account pages
const AccountLayout = ({ children }) => {
  return (
    <AccountAuthProvider>
      {children}
    </AccountAuthProvider>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Account pages - no main layout (for WebView) */}
        <Route path="/app/account" element={
          <AccountLayout>
            <AccountEntry />
          </AccountLayout>
        } />
        <Route path="/app/account/dashboard" element={
          <AccountLayout>
            <AccountDashboard />
          </AccountLayout>
        } />
        <Route path="/app/account/plans" element={
          <AccountLayout>
            <AccountPlans />
          </AccountLayout>
        } />
        <Route path="/app/account/checkout" element={
          <AccountLayout>
            <AccountCheckout />
          </AccountLayout>
        } />
        <Route path="/app/account/checkout/success" element={
          <AccountLayout>
            <AccountCheckoutSuccess />
          </AccountLayout>
        } />
        <Route path="/app/account/payment" element={
          <AccountLayout>
            <AccountPayment />
          </AccountLayout>
        } />
        <Route path="/app/account/cancel" element={
          <AccountLayout>
            <AccountCancel />
          </AccountLayout>
        } />
        <Route path="/app/account/payment-history" element={
          <AccountLayout>
            <AccountPaymentHistory />
          </AccountLayout>
        } />
        <Route path="/app/account/my-subscription" element={
          <AccountLayout>
            <AccountMySubscription />
          </AccountLayout>
        } />
        <Route path="/app/account/business-profile" element={
          <AccountLayout>
            <AccountBusinessProfile />
          </AccountLayout>
        } />
        
        {/* Guarantor review - standalone page (no auth, no layout) */}
        <Route path="/guarantor/review/:token" element={<GuarantorReview />} />

        {/* Deal payment link - standalone page (no auth, no layout) */}
        <Route path="/pay/deal/:token" element={<PayDeal />} />
        
        {/* Main website pages with layout */}
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsConditions />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/mockups" element={<MockupPreview />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
